<template>

	<div class="page-content" style="height: 100vh;">
		<div class="content-wrapper">
			<div class="content-inner overflow-hidden">
				<div class="page-header page-header-light shadow">
					<div class="page-header-content d-lg-flex">
						<div class="d-flex">
							<h4 class="page-title mb-0">
								File Manager
							</h4>
							<a href="#page_header"
								class="btn btn-light align-self-center collapsed d-lg-none border-transparent rounded-pill p-0 ms-auto"
								data-bs-toggle="collapse">
								<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
							</a>
						</div>
						<div class="collapse d-lg-block my-lg-auto ms-lg-auto" id="page_header">
							<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
								<div class="dropdown w-100 w-sm-auto">
									<div class="input-group">
										<span class="input-group-text"><i class="ph-globe-hemisphere-east"></i></span>
										<select class="form-select form-select-sm" data-placeholder="Ente" v-model="idEnteCorrente" @change="goToRoot()">
											<option v-for="ente in $root.arrayEnti" v-bind:key="ente.ID_ENTE" v-bind:value="ente.ID_ENTE"> {{ ente.LABEL }}</option>
										</select>
									</div>
								</div>

							</div>
						</div>
					</div>
					<div class="page-header-content d-lg-flex border-top">
						<div class="d-flex">
							<div class="breadcrumb py-2">
								<a href="#" class="breadcrumb-item" @click.prevent="goToRoot">
									<i class="fa fa-home"></i>
								</a>
								<template v-for="(folder, index) in pathSegments" :key="index">
									<a v-if="index < pathSegments.length - 1" href="#" class="breadcrumb-item"
										@click.prevent="goToPath(index)">
										{{ folder }}
									</a>
									<span v-else class="breadcrumb-item active">{{ folder }}</span>
								</template>

							</div>
							<a href="#breadcrumb_elements"
								class="btn btn-light align-self-center collapsed d-lg-none border-transparent rounded-pill p-0 ms-auto"
								data-bs-toggle="collapse">
								<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
							</a>
						</div>

						<div class="collapse d-lg-block ms-lg-auto" id="breadcrumb_elements">
							<div class="d-lg-flex mb-2 mb-lg-0">
								<a href="#" class="d-flex align-items-center text-body py-2">
									<i class="ph-lifebuoy me-2"></i>
									Support
								</a>
								<div class="dropdown ms-lg-3">
									<a href="#" class="d-flex align-items-center text-body dropdown-toggle py-2"
										data-bs-toggle="dropdown">
										<i class="ph-gear me-2"></i>
										<span class="flex-1">Settings</span>
									</a>
									<div class="dropdown-menu dropdown-menu-end w-100 w-lg-auto">
										<a href="#" class="dropdown-item">
											<i class="ph-shield-warning me-2"></i>
											Account security
										</a>
										<a href="#" class="dropdown-item">
											<i class="ph-chart-bar me-2"></i>
											Analytics
										</a>
										<a href="#" class="dropdown-item">
											<i class="ph-lock-key me-2"></i>
											Privacy
										</a>
										<div class="dropdown-divider"></div>
										<a href="#" class="dropdown-item">
											<i class="ph-gear me-2"></i>
											All settings
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content ">
					<div class="d-lg-flex">
						<div class="sidebar sidebar-component sidebar-expand-lg bg-transparent shadow-none me-lg-3"
							style="width: 20% !important;">
							<div class="sidebar-content">
								<div class="card" style="height: calc(100vh - 300px);">
									<div class="sidebar-section-header border-bottom d-flex align-items-center justify-content-between px-2"
										style="height: 70px;">
										<span class="fw-semibold">Navigation</span>
										<select v-model="currentRoot" @change="onRootChange"
											class="form-select form-select-sm me-2" style="width: auto;">
											<option v-for="path in rootOptions" :key="path" :value="path">{{
												filters.getFileFromPath(path) }}</option>
										</select>

									</div>
									<ul class="nav nav-sidebar" data-nav-type="accordion"
										style=" padding-left: 10px; overflow: auto;">
										<div class="list-group list-group-flush">
											<FileManagerTreeNode v-for="node in tree" :key="node.fullPath" :node="node"
												@select="handleTreeSelect" @expand="loadChildren"
												@toggle-expand="toggleExpand" @toggle-select="toggleSelect" />
										</div>
									</ul>
								</div>
							</div>
						</div>
						<div class="flex-1" style="width: 80% !important;">
							<div class="card" style="height: calc(100vh - 300px);">
								<div class="card-header d-flex justify-content-between align-items-center">
									<div class="nav nav-tabs card-header-tabs">
										<button class="nav-link" :class="{ active: activeTab == 'file' }"
											@click="activeTab = 'file'">
											<i class="fas fa-folder-open me-1"></i> File
										</button>
										<button class="nav-link" :class="{ active: activeTab == 'upload' }"
											@click="activeTab = 'upload'">
											<i class="fas fa-upload me-1"></i> Upload
										</button>

									</div>
									<div class="ms-3 d-inline-flex align-items-center"
										style="min-width: 120px; justify-content: end;">

										<!-- SELEZIONE -->
										<div v-if="hasSelection"
											class="selection-bar d-inline-flex gap-2 align-items-center px-2 me-2">
											<template v-if="isSingleSelection">
												<a href="#" class="btn btn-link text-body-light p-0"
													@click.prevent="showInfo">
													<i class="fas fa-info-circle me-1"></i>
												</a>
												<a href="#" class="btn btn-link text-body-light p-0"
													@click.prevent="renameSelected">
													<i class="fas fa-i-cursor me-1"></i>
												</a>
												<a href="#" class="btn btn-link text-body-light p-0"
													@click.prevent="deleteSelected">
													<i class="fas fa-trash-alt me-1"></i>
												</a>
												<a href="#" class="btn btn-link text-body-light p-0"
													@click.prevent="downloadSelected">
													<i class="fas fa-download me-1"></i>
												</a>
											</template>
											<template v-else>
												<a href="#" class="btn btn-link text-body-light p-0"
													@click.prevent="deleteSelected">
													<i class="fas fa-trash-alt me-1"></i>
												</a>
												<a href="#" class="btn btn-link text-body-light p-0"
													@click.prevent="downloadSelected">
													<i class="fas fa-download me-1"></i>
												</a>
											</template>
										</div>

										<!-- FISSI -->
										<!-- DROPDOWN SORT -->
										<a href="#" class="nav-link" @click.prevent="selectAll()">
											<i class="fas fa-check-square me-2" aria-hidden="true"></i>
										</a>
										<div class="dropdown me-2">

											<a href="#" class="nav-link" data-bs-toggle="dropdown">
												<i class="fas fa-sort me-2"></i>
											</a>
											<ul class="dropdown-menu">
												<li>
													<a class="dropdown-item" @click="setSort('name')">
														Nome <span v-if="sortBy == 'name'">({{ sortOrderLabel
														}})</span>
													</a>
												</li>
												<li>
													<a class="dropdown-item" @click="setSort('type')">
														Tipo <span v-if="sortBy == 'type'">({{ sortOrderLabel
														}})</span>
													</a>
												</li>
												<li>
													<a class="dropdown-item" @click="setSort('size')">
														Dimensione <span v-if="sortBy == 'size'">({{ sortOrderLabel
														}})</span>
													</a>
												</li>
												<li>
													<a class="dropdown-item" @click="setSort('date')">
														Data <span v-if="sortBy == 'date'">({{ sortOrderLabel
														}})</span>
													</a>
												</li>
											</ul>
										</div>

										<a href="#" class="nav-link" @click.prevent="createFile">
											<i class="fas fa-file-circle-plus me-2"></i>
										</a>
										<a href="#" class="nav-link" @click.prevent="createFolder">
											<i class="fas fa-folder-plus me-2"></i>
										</a>
										<a href="#" @click.prevent="toggleViewMode"
											class="btn btn-link text-body-light p-0">
											<i :class="viewMode == 'grid' ? 'fa fa-bars' : 'fa fa-th'"></i>
										</a>
									</div>

								</div>
								<div class="card-body" style="overflow-y: auto;">
									<div v-if="activeTab == 'file'">
										<div v-if="viewMode == 'grid'" class="d-flex flex-wrap gap-1">
											<div v-for="file in sortedFiles" :key="file.name"
												class="d-flex justify-content-center p-1">
												<div :class="['file-card card text-center', selectedFiles.some(f => f.name == file.name && f.fullPath == file.fullPath) ? 'selected' : '']"
													@click="handleSelection(file, index, $event)"
													@dblclick="file.type == 'Cartella' && openFolder(file.name)"
													style="width: 100px; height: 110px; padding: 0.5rem; display: flex; flex-direction: column; justify-content: center; align-items: center;">
													<template v-if="isImage(file.name)">
														<img :src="getPreviewUrl(file)" alt="preview"
															style="width: 32px; height: 32px; object-fit: contain;" />
													</template>
													<template v-else>
														<i :class="file.icon + ' fa-2x'"
															style="margin-bottom: 0.4rem;"></i>
													</template>
													<a href="#" class="btn btn-sm btn-link text-primary mt-1"
														@click.prevent="showPreview(file)">
														<i class="fas fa-eye"></i>
													</a>


													<div class="fw-semibold small text-truncate" :title="file.name"
														style="max-width: 100%;">
														{{ file.name }}
													</div>
													<small class="text-muted" style="font-size: 0.7rem;">
														{{ file.type }} - {{ filters.formatBytes(file.size) }}
													</small>
												</div>
											</div>
										</div>
										<div v-else class="table-responsive">
											<table class="table table-sm table-hover">
												<thead>
													<tr>
														<th>Nome</th>
														<th>Tipo</th>
														<th>Dimensione</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(file, index) in sortedFiles" :key="file.name"
														@click="handleSelection(file, index, $event)"
														@dblclick="file.type == 'Cartella' && openFolder(file.name)"
														:class="{ 'table-primary': selectedFiles.some(f => f.name == file.name && f.fullPath == file.fullPath) }"
														style="cursor: pointer;">
														<td :title="file.name">
															<i :class="file.icon + ' me-2'"></i> {{ file.name }}
														</td>
														<td>{{ file.type }}</td>
														<td>{{ filters.formatBytes(file.size) }}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									<div v-else class="border border-dashed p-4 rounded bg-light text-center">
										<div class="p-4 border border-dashed rounded bg-white" @drop.prevent="onDrop"
											@dragover.prevent style="cursor: pointer" @click="triggerFileInput">
											<i class="fas fa-cloud-upload-alt fa-2x mb-2 text-secondary"></i>
											<div class="fw-semibold mb-2">Trascina qui i file/cartelle oppure clicca per
												selezionare
											</div>
										</div>

										<div class="mt-3 d-flex flex-wrap gap-2 justify-content-center">
											<button class="btn btn-sm btn-outline-secondary"
												@click="triggerFileInput">Select
												Files</button>
											<button class="btn btn-sm btn-outline-secondary" @click="clearAll">Clear
												all</button>
											<button class="btn btn-sm btn-outline-success" @click="upload"
												:disabled="uploadedFiles.length == 0">Conferma Upload</button>

										</div>

										<div class="mt-3 small text-muted">
											<div v-if="uploadedFiles.length > 0">
												<p>{{ uploadedFiles.length }} file selezionati:</p>
												<div
													class="uploaded-preview-bar d-flex flex-nowrap overflow-auto gap-2 px-2 py-2">
													<div v-for="(file, index) in uploadedFiles" :key="file.name + index"
														class="d-flex flex-column align-items-center justify-content-center border rounded p-2 bg-white"
														style="min-width: 90px; max-width: 100px;">

														<!-- Anteprima -->
														<img v-if="file && isImage(file.name)"
															:src="getFilePreview(file)" alt="preview"
															style="width: 48px; height: 48px; object-fit: cover; border-radius: 4px;" />

														<i v-else class="fas fa-file fa-2x text-muted mb-1"></i>

														<!-- Nome + remove -->
														<div class="text-truncate small w-100" :title="file.name">{{
															file.name }}</div>
														<button class="btn btn-sm btn-link text-danger p-0 mt-1"
															@click="uploadedFiles.splice(index, 1)">
															<i class="fas fa-times"></i>
														</button>
													</div>
												</div>


											</div>
											<div v-else>Nessun file selezionato</div>
										</div>


										<input ref="fileInput" type="file" class="d-none" multiple
											@change="onFilesSelected" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal Crea -->
	<div class="modal fade" id="modalCreate" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">{{ isCreatingFolder ? 'Nuova cartella' : 'Nuovo file' }}</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<label class="form-label">Nome</label>
					<input v-model="newItemName" type="text" class="form-control" placeholder="Nome file..." />

					<!-- Estensione visibile solo per i file -->
					<div v-if="!isCreatingFolder" class="mt-3">
						<label class="form-label">Tipo di estensione</label>
						<select v-model="extensionCategory" class="form-select">
							<option disabled value="">Seleziona categoria</option>
							<option value="text">Testo</option>
							<option value="code">Codice</option>
							<option value="doc">Documenti</option>
							<option value="img">Immagini</option>
							<option value="other">Altro</option>
						</select>

						<div v-if="extensionCategory" class="mt-2">
							<label class="form-label">Estensione</label>
							<select v-model="selectedExtension" class="form-select">
								<option v-for="ext in extensions[extensionCategory]" :key="ext" :value="ext">
									{{ ext }}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
					<button class="btn btn-primary" @click="confirmCreate">Crea</button>
				</div>
			</div>
		</div>
	</div>



	<!-- Modal Rinomina -->
	<div class="modal fade" id="modalRename" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Rinomina</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<label class="form-label">Nome file</label>
					<input v-model="renameBaseName" type="text" class="form-control" :disabled="allowExtensionEdit" />
					<div v-if="selectedFiles.length > 0 && selectedFiles[0].type != 'Cartella'">
						<div class="mt-2 d-flex align-items-center gap-2" v-if="!allowExtensionEdit">
							<span class="text-muted">Estensione: <strong>{{ renameExtension }}</strong></span>
						</div>

						<div class="form-check mt-3">
							<input class="form-check-input" type="checkbox" v-model="allowExtensionEdit"
								id="checkEditExt" />
							<label class="form-check-label" for="checkEditExt">
								Abilita modifica estensione
							</label>
						</div>

						<div v-if="allowExtensionEdit" class="mt-2">
							<label class="form-label">Nome completo</label>
							<input v-model="renameNewName" type="text" class="form-control" />
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
					<button class="btn btn-primary" @click="confirmRename">Salva</button>
				</div>
			</div>
		</div>
	</div>


	<!-- Modal Conferma Eliminazione -->
	<div class="modal fade" id="modalDeleteConfirm" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Conferma eliminazione</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					Sei sicuro di voler eliminare <strong>{{ selectedFiles.length }}</strong> elemento/i?
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
					<button class="btn btn-danger" @click="confirmDelete">Elimina</button>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal Info -->
	<div class="modal fade" id="modalInfo" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Proprietà file</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body" v-if="infoFile">
					<ul class="list-unstyled">
						<li><strong>Nome:</strong> {{ infoFile.name }}</li>
						<li><strong>Tipo:</strong> {{ infoFile.type }}</li>
						<li><strong>Dimensione:</strong> {{ filters.formatBytes(infoFile.size) }}</li>
						<li><strong>Permessi:</strong> {{ filters.translatePermissions(infoFile.permissions) }}</li>
						<li><strong>Proprietario:</strong> {{ infoFile.owner }}</li>
						<li><strong>Gruppo:</strong> {{ infoFile.group }}</li>
						<li><strong>Data:</strong> {{ infoFile.date }}</li>
					</ul>
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal Conferma Sovrascrittura -->
	<div class="modal fade" id="modalOverwriteConfirm" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">File o cartella già esistente</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					Esiste già un file o una cartella con questo nome. Vuoi sovrascrivere?
				</div>
				<div class="modal-footer">
					<button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
					<button class="btn btn-danger" @click="proceedOverwrite">Sovrascrivi</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal Loading -->
	<div class="modal fade" id="modalLoading" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
		<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content text-center">
				<div class="modal-body">
					<div class="spinner-border text-primary mb-3" role="status"></div>
					<p>Download in corso...</p>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal Preview File -->
	<!-- Modal Preview -->
	<!-- Mantieni sempre il modale nel DOM -->
	<div class="modal fade" id="modalPreview" tabindex="-1">
		<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content" v-if="previewFile">
				<div class="modal-header">
					<h5 class="modal-title">{{ previewFile.name }}</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" @click="handleEditorClose"></button>
				</div>
				<component :is="getEditorComponent(previewFile.name)" :file="previewFile" :initial-content="previewText"
					@close="handleEditorClose" @salvato="reloadCurrentPath(true)" />
			</div>
		</div>
	</div>







</template>

<script>
import FileManagerTreeNode from './FileManagerTreeNode.vue';
import ImageEditor from './utils/ImageEditor.vue';
import PdfEditor from './utils/PdfEditor.vue';
import ExcelEditor from './utils/ExcelEditor.vue';
import WordEditor from './utils/WordEditor.vue';
import CodeEditor from './utils/CodeEditor.vue';




export default {
	name: 'FileManager',
	components: {
		FileManagerTreeNode,
		CodeEditor,
		ImageEditor,
		PdfEditor,
		ExcelEditor,
		WordEditor
	},
	data() {
		return {
			filters: global.filters,
			currentPath: '',
			searchQuery: '',
			activeTab: 'file',
			viewMode: 'grid',
			selectedFiles: [],
			lastSelectedIndex: null,
			uploadedFiles: [],
			files: new Array(),
			history: [],
			historyIndex: -1,
			newItemName: '',
			renameNewName: '',
			isCreatingFolder: true,
			modalita: 'uploadFtpFileGenerico',
			selectedExtension: '.txt',
			extensionCategory: '',
			extensions: {
				text: ['.txt', '.md', '.csv', '.log'],
				code: ['.js', '.ts', '.vue', '.py', '.php', '.html', '.css', '.json', '.java', '.cpp', '.c', '.rb'],
				doc: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'],
				img: ['.jpg', '.jpeg', '.png', '.gif', '.svg', '.webp'],
				other: ['.xml', '.yml', '.ini', '.conf', '.zip', '.rar']
			},
			renameBaseName: '',
			renameExtension: '',
			allowExtensionEdit: false,
			infoFile: null,
			pendingCreate: null,
			pendingRename: null,
			tree: [],
			rootPath: '',
			rootOptions: [],
			currentRoot: '',
			sortBy: 'name',
			sortOrder: 'asc',
			previewText: '',
			previewFile: null,
			idEnteCorrente:0,



		}
	},
	methods: {
		validateCurrentPath(callback = null) {
			utils.ajax('ftp/exists', { path: this.currentPath }, (response) => {
				if (response.esito == 0 && response.data.exists) {
					this.reloadCurrentPath(true);
					if (callback) callback();
				} else {
					utils.alert.warning('La cartella corrente non esiste più. Torno alla root.');
					this.navigateTo(this.rootPath);
					this.loadInitialTree(this.rootPath);
				}
			});
		},
		getFullPath(name) {
			return `${this.currentPath}/${name}`.replace(/\/+/g, '/');
		},
		handleEditorClose() {
			if (this.previewFile) {
				utils.ajax('ftp/unlock-file', {
					PATH: this.previewFile.fullPath,
					ID_UTENTE: this.$root.utente.ID_UTENTE,
				}, () => { });

			}
			this.filters.closePopUp('modalPreview');
			this.previewFile = null;
			this.previewText = '';
		},


		getEditorComponent(name) {
			if (this.isCode(name)) return 'CodeEditor'
			if (this.isImage(name)) return 'ImageEditor'
			if (this.isPdf(name)) return 'PdfEditor'
			if (this.isExcel(name)) return 'ExcelEditor'
			if (this.isWordOrOdt(name)) return 'WordEditor'
			return null
		},
		salvaModifichePdf(data) {
			utils.ajax('ftp/save-pdf-overlay', data, response => {
				if (response.esito == 0) {
					utils.alert.success('PDF modificato con successo!');
				} else {
					utils.alert.danger('Errore durante il salvataggio PDF');
				}
			});
		},

		salvaImmagineModificata(base64Image) {
			const file = this.previewFile;
			const contenuto = base64Image.split(',')[1];

			utils.ajax('ftp/save-preview-image', {
				path: file.fullPath,
				content: contenuto
			}, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Immagine salvata con successo!');
				} else {
					utils.alert.danger('Errore durante il salvataggio.');
				}
			});
		},

		salvaModifiche() {
			const file = this.previewFile;
			const contenuto = this.previewText;

			utils.ajax('ftp/save-code-file', {
				path: file.fullPath,
				content: contenuto
			}, (response) => {
				if (response.esito == 0) {
					utils.alert.success('File di testo salvato con successo!');
				} else {
					utils.alert.danger('Errore durante il salvataggio.');
				}
			});
		},

		isCode(name) {
			return /\.(js|php|html|css|json|vue|ts|c|cpp|py)$/i.test(name);
		},
		getLanguage(name) {
			if (!name) return 'plaintext';
			const ext = name.split('.').pop().toLowerCase();
			const map = {
				js: 'javascript',
				ts: 'typescript',
				php: 'php',
				html: 'html',
				css: 'css',
				json: 'json',
				vue: 'html',
				py: 'python',
				cpp: 'cpp',
				c: 'c'
			};
			return map[ext] || 'plaintext';
		},

		isPdf(name) {
			return /\.pdf$/i.test(name);
		},
		isText(name) {
			return /\.(txt|json|csv|log|md|html|js|php|css)$/i.test(name);
		},
		isExcel(name) {
			return /\.(xls|xlsx|ods)$/i.test(name);
		},
		isWordOrOdt(name) {
			return /\.(docx|odt)$/i.test(name);
		},
		showPreview(file) {
			utils.ajax('ftp/check-lock', { PATH: file.fullPath }, (response) => {
				const lock = response.data;
				if (lock.LOCKED && lock.ID_UTENTE != this.$root.utente.ID_UTENTE) {
					utils.alert.warning(`Il file ${lock.FILE} è attualmente in uso da ${lock.USERNAME}`);
					return;
				}

				this.previewFile = file;
				utils.ajax('ftp/lock-file', {
					PATH: file.fullPath,
					ID_UTENTE: this.$root.utente.ID_UTENTE
				}, () => { });


				if (this.isCode(file.name) || this.isText(file.name)) {
					utils.ajaxText('ftp/get-preview', { path: file.fullPath }, (response) => {
						this.previewText = response;
						this.filters.openPopUp('modalPreview');
					});
				} else {
					this.previewText = '';
					this.filters.openPopUp('modalPreview');
				}
			});
		},
		isImage(name) {
			return /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(name);
		},
		getPreviewUrl(file) {
			const cacheKey = file.previewKey || '';
			return `${global.utils.BASE_API}ftp/get-preview?path=${encodeURIComponent(file.fullPath)}&t=${cacheKey}`;
		},

		goToRoot() {
			utils.ajax('ftp/root', {ID_ENTE:this.idEnteCorrente}, (response) => {
				if (response.esito == 0) {
					this.rootPath = response.data.root;
					this.rootOptions = response.data.rootOptions;
					this.currentRoot = this.rootPath;
					this.loadInitialTree(response.data.root);
					this.navigateTo(this.rootPath);
				}
			});
		},
		handleSelection(file, index, event) {
			const fullPath = `${this.currentPath}/${file.name}`.replace(/\/+/g, '/');
			const item = { ...file, fullPath };

			if (event.ctrlKey || event.metaKey) {
				const i = this.selectedFiles.findIndex(f => f.fullPath == fullPath);
				if (i >= 0) {
					this.selectedFiles.splice(i, 1);
				} else {
					this.selectedFiles.push(item);
				}
				this.lastSelectedIndex = index;
			} else if (event.shiftKey && this.lastSelectedIndex != null) {
				const range = [this.lastSelectedIndex, index].sort((a, b) => a - b);
				const rangeItems = this.filteredFiles.slice(range[0], range[1] + 1).map(f => ({
					...f,
					fullPath: `${this.currentPath}/${f.name}`.replace(/\/+/g, '/')
				}));
				this.selectedFiles = [...new Set([...this.selectedFiles, ...rangeItems])];
			} else {
				this.selectedFiles = [item];
				this.lastSelectedIndex = index;
			}
		},
		handleKeyNavigation(e) {
			const files = this.filteredFiles;
			if (!files.length) return;
			let index = files.findIndex(f => f.name == this.selectedFiles[0]);
			if (e.key == 'ArrowDown') {
				index = Math.min(index + 1, files.length - 1);
				this.selectedFiles = [files[index].name];
				this.lastSelectedIndex = index;
			}
			if (e.key == 'ArrowUp') {
				index = Math.max(index - 1, 0);
				this.selectedFiles = [files[index].name];
				this.lastSelectedIndex = index;
			}
			if (e.key == 'Enter') {
				const selected = files[index];
				if (selected?.type == 'Cartella') this.openFolder(selected.name);
			}
		},

		goToPath(index) {
			const parts = this.pathSegments.slice(0, index + 1);
			const newPath = `${this.rootPath}/${parts.join('/')}`.replace(/\/+/g, '/');
			this.navigateTo(newPath);
		},
		goBack() {
			if (this.historyIndex > 0) {
				this.historyIndex--;
				this.currentPath = this.history[this.historyIndex];
				this.reloadCurrentPath();
			}
		},
		goForward() {
			if (this.historyIndex < this.history.length - 1) {
				this.historyIndex++;
				this.currentPath = this.history[this.historyIndex];
				this.reloadCurrentPath();
			}
		},
		toggleMinimize() {
			this.isMinimized = !this.isMinimized
		},
		closePanel() {
			this.$emit('close')
		},
		toggleViewMode() {
			this.viewMode = this.viewMode == 'grid' ? 'table' : 'grid'
		},
		createFile() {
			this.newItemName = ''
			this.isCreatingFolder = false
			this.filters.openPopUp('modalCreate')

		},
		createFolder() {
			this.newItemName = ''
			this.isCreatingFolder = true
			this.filters.openPopUp('modalCreate')
		},
		confirmCreate() {
			const baseName = this.newItemName.trim();
			let fullName = baseName;
			if (!this.isCreatingFolder && this.selectedExtension && !baseName.endsWith(this.selectedExtension)) {
				fullName += this.selectedExtension;
			}
			if (this.files.some(f => f.name == fullName)) {
				this.pendingCreate = {
					fullName,
					endpoint: this.isCreatingFolder ? 'ftp/create-folder' : 'ftp/create-file'
				};
				this.filters.openPopUp('modalOverwriteConfirm');
				return;
			}
			this.executeCreate(fullName);
		},
		executeCreate(fullName) {
			const fullPath = this.getFullPath(fullName);
			const endpoint = this.isCreatingFolder ? 'ftp/create-folder' : 'ftp/create-file';
			utils.ajax(endpoint, { path: fullPath }, (response) => {
				if (response.esito == 0) {
					utils.alert.success(this.isCreatingFolder ? 'Cartella creata' : 'File creato');
					this.validateCurrentPath();

				} else {
					utils.alert.danger('Errore nella creazione');
				}
				this.filters.closePopUp('modalCreate');
				this.resetModalData();
			});
		},

		refreshFiles() {
			utils.ajax('ftp/list', { path: this.currentPath }, (response) => {
				if (response.esito == 0) {
					this.files = response.data
						.filter(item => item.type != 'directory')
						.map(item => ({
							name: item.name,
							icon: item.icon,
							type: 'File',
							size: item.size ?? '-',
							permissions: item.permissions,
							owner: item.owner,
							group: item.group,
							date: `${item.month} ${item.day} ${item.timeOrYear}`,
							fullPath: this.getFullPath(item.name)
						}));
					this.previousPath = this.currentPath;
					this.resetSelection();
				}
			});
		},

		triggerFileInput() { this.$refs.fileInput.click() },

		upload() {
			if (!this.uploadedFiles.length) return;

			let formData = new FormData();

			this.uploadedFiles.forEach((f, x) => {
				formData.append('file' + (x + 1), f);
			});

			const args = {
				path: this.currentPath,
				isAvatar: false,
				modalita: 'uploadFtpFileGenerico'
			};

			formData.append('args', JSON.stringify(args));

			utils.uploadAjax('ftp/basic/upload', formData, (response) => {

				utils.unblockPage();

				if (typeof response == 'string') {
					response = JSON.parse(response);
				}

				if (response.esito == 0) {
					this.reloadCurrentPath(true);
					utils.alert.success('File caricato con successo');
				} else {
					utils.alert.danger(response.messaggio || 'Errore durante l\'upload');
				}
			}, true, 1);
			this.uploadedFiles = [];
		},

		onDrop(e) {
			this.uploadedFiles.push(...Array.from(e.dataTransfer.files));
		},
		clearAll() {
			this.uploadedFiles = []
			alert('Tutti i file sono stati rimossi')
		},
		openFolder(folderName) {
			const newPath = `${this.currentPath}/${folderName}`.replace(/\/+/g, '/');
			this.navigateTo(newPath);
		},
		navigateTo(newPath) {
			if (this.historyIndex < this.history.length - 1) {
				this.history = this.history.slice(0, this.historyIndex + 1);
			}
			this.history.push(newPath);
			this.historyIndex++;
			this.currentPath = newPath;
			this.reloadCurrentPath();
		},
		renameSelected() {
			this.renameNewName = this.selectedFiles[0].name;
			const parts = this.renameNewName.split('.');
			this.renameExtension = parts.length > 1 ? '.' + parts.pop() : '';
			this.renameBaseName = parts.join('.');
			this.allowExtensionEdit = false;
			this.filters.openPopUp('modalRename')
		},
		confirmRename() {
			const oldFile = this.selectedFiles[0];
			const oldPath = oldFile.fullPath;
			const finalName = this.allowExtensionEdit ? this.renameNewName : `${this.renameBaseName}${this.renameExtension}`;
			const newPath = this.getFullPath(finalName);

			if (this.files.some(f => f.name == finalName && f.name != oldFile.name)) {
				this.pendingRename = { oldPath, newPath, finalName };
				this.filters.openPopUp('modalOverwriteConfirm');
				return;
			}
			this.executeRename(oldPath, newPath, finalName);
		},
		executeRename(oldPath, newPath, finalName) {
			utils.ajax('ftp/rename', { oldPath, newPath }, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Rinominato con successo');
					this.validateCurrentPath();
					setTimeout(this.resetSelection, 50);
				} else {
					utils.alert.danger('Errore nella rinomina');
				}
				this.filters.closePopUp('modalRename');
				this.resetModalData();
			});
		},
		deleteSelected() {
			this.filters.openPopUp('modalDeleteConfirm')
		},

		confirmDelete() {
			const paths = this.selectedFiles.map(f => f.fullPath);
			utils.ajax('ftp/delete', { paths }, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Eliminazione riuscita');
					this.selectedFiles = [];
					this.validateCurrentPath();
				} else {
					utils.alert.danger('Errore durante eliminazione');
				}
				this.filters.closePopUp('modalDeleteConfirm');
				this.resetModalData();
			});
		},

		downloadSelected() {
			if (this.selectedFiles.length == 0) {
				utils.alert.info('Seleziona almeno un file');
				return;
			}

			const isOnlyOne = this.selectedFiles.length == 1;
			const paths = this.selectedFiles.map(f => f.fullPath);
			const selected = this.selectedFiles[0];

			const isFolder = isOnlyOne && selected.type == 'directory';

			const done = () => this.hideLoadingModal?.();

			if (isOnlyOne && !isFolder) {
				// Singolo FILE
				utils.downloadFile('ftp/download', { path: paths[0] }, selected.name, done);
			} else if (isOnlyOne && isFolder) {
				// Singola CARTELLA => ZIP
				utils.downloadFile('ftp/download-folder', { path: paths[0] }, selected.name, done);
			} else {
				// Più elementi => ZIP
				utils.downloadFile('ftp/download-multiple', { paths }, 'files', done);
			}
		},
		onFilesSelected(e) {
			this.uploadedFiles.push(...Array.from(e.target.files));
		},
		showInfo() {
			if (!this.selectedFiles.length) return;
			const selected = this.selectedFiles[0];
			this.infoFile = this.files.find(f => f.fullPath == selected.fullPath);
			this.filters.openPopUp('modalInfo');
		},
		proceedOverwrite() {
			this.filters.closePopUp('modalOverwriteConfirm');
			if (this.pendingCreate) {
				this.executeCreate(this.pendingCreate.fullName);
				this.pendingCreate = null;
			} else if (this.pendingRename) {
				this.executeRename(this.pendingRename.oldPath, this.pendingRename.newPath, this.pendingRename.finalName);
				this.pendingRename = null;
			}
			this.resetModalData();
		},
		loadInitialTree(path) {
			utils.ajax('ftp/list', { path: path }, (response) => {
				if (response.esito == 0) {
					this.tree = response.data
						.filter(item => item.type == 'directory')
						.map(item => ({
							name: item.name,
							fullPath: `${this.rootPath}/${item.name}`.replace(/\/+/g, '/'),
							path: `${this.rootPath}/${item.name}`.replace(/\/+/g, '/'),
							type: 'directory',
							hasChildren: true,
							expanded: false,
							selected: false,
							children: null
						}));

				}
			});
			this.resetSelection();
		},
		loadChildren(node) {
			if (node.loading || (node.children && node.children.length > 0)) return;
			node.loading = true;

			utils.ajax('ftp/list', { path: node.fullPath }, (response) => {
				if (response.esito == 0) {
					const subdirs = response.data.filter(item => item.type == 'directory');
					node.children = subdirs.map(item => ({
						name: item.name,
						type: 'directory',
						fullPath: `${node.fullPath}/${item.name}`.replace(/\/+/g, '/'),
						hasChildren: item.hasChildren || false,
						expanded: false,
						selected: false,
						children: null
					}));
					node.hasChildren = subdirs.length > 0;
				} else {
					node.children = [];
					node.hasChildren = false;
				}
				node.loading = false;
			}, false);
		},
		toggleExpand(node) {
			if (node.type != 'directory') return;
			node.expanded = !node.expanded;
			this.$emit('expand', node);
		},
		toggleSelect(node) {
			const isNowSelected = !node.selected;
			node.selected = isNowSelected;

			const index = this.selectedFiles.findIndex(f => f.fullPath == node.fullPath);
			if (isNowSelected && index == -1) {
				this.selectedFiles.push({
					name: node.name,
					fullPath: node.fullPath,
					type: node.type,
					size: node.size ?? '-',
					icon: node.type == 'directory' ? 'fas fa-folder' : 'fas fa-file'
				});
			} else if (!isNowSelected && index >= 0) {
				this.selectedFiles.splice(index, 1);
			}


			const markChildrenSelection = (children, selected) => {
				if (!children) return;
				children.forEach(child => {
					child.selected = selected;
					if (child.children) {
						markChildrenSelection(child.children, selected);
					}
				});
			};
			markChildrenSelection(node.children, isNowSelected);
		},

		handleTreeSelect(node) {
			this.navigateTo(node.fullPath);
		},
		reloadCurrentPath(reloadTree = false) {
			const modal = document.getElementById('modalPreview');
			const isOpen = modal?.classList.contains('show');

			if (isOpen) {
				this.handleEditorClose();
			}

			this.refreshFiles();
			this.files = this.files.map(f => ({
				...f,
				previewKey: Date.now()
			}));

			if (reloadTree) this.loadInitialTree(this.rootPath);
		},
		onRootChange() {
			this.rootPath = this.currentRoot;
			this.tree = [];
			this.navigateTo(this.rootPath);
			this.loadInitialTree(this.rootPath);
		},
		setSort(field) {
			if (this.sortBy == field) {
				this.sortOrder = this.sortOrder == 'asc' ? 'desc' : 'asc';
			} else {
				this.sortBy = field;
				this.sortOrder = 'asc';
			}
		},
		resetSelection() {
			this.selectedFiles = [];
			this.lastSelectedIndex = null;
		},
		getFilePreview(file) {
			try {
				return URL.createObjectURL(file);
			} catch (e) {
				console.warn('Errore preview file:', e);
				return '';
			}
		},
		resetModalData() {
			this.newItemName = '';
			this.extensionCategory = '';
			this.selectedExtension = '.txt';
			this.renameBaseName = '';
			this.renameExtension = '';
			this.renameNewName = '';
			this.allowExtensionEdit = false;
			this.infoFile = null;
			this.pendingCreate = null;
			this.pendingRename = null;
		},
		selectAll() {
			const allVisible = this.filteredFiles.map(file => ({
				...file,
				fullPath: `${this.currentPath}/${file.name}`.replace(/\/+/g, '/')
			}));

			const areAllSelected = allVisible.every(f =>
				this.selectedFiles.some(s => s.fullPath == f.fullPath)
			);
			if (areAllSelected) {
				this.selectedFiles = [];
			} else {
				this.selectedFiles = allVisible;
			}
		},
		onExcelSaved() {
			utils.alert.success("Excel salvato correttamente!");
		}


	},
	computed: {
		filteredFiles() {
			if (!this.searchQuery.trim()) return this.files;
			return this.files.filter(f =>
				f.name.toLowerCase().includes(this.searchQuery.toLowerCase())
			);
		},
		pathSegments() {
			const rootParts = this.rootPath.replace(/^\/+|\/+$/g, '').split('/');
			const fullParts = this.currentPath.replace(/^\/+|\/+$/g, '').split('/');
			return fullParts.slice(rootParts.length);
		},

		isSingleSelection() {
			return this.selectedFiles.length == 1;
		},
		hasSelection() {
			return this.selectedFiles.length > 0;
		},
		sortedFiles() {
			const files = this.filteredFiles.slice();
			const { sortBy, sortOrder } = this;

			files.sort((a, b) => {
				let valA = a[sortBy];
				let valB = b[sortBy];

				if (sortBy == 'name' || sortBy == 'type') {
					valA = valA.toLowerCase();
					valB = valB.toLowerCase();
				} else if (sortBy == 'size') {
					valA = parseInt(valA);
					valB = parseInt(valB);
				}

				if (valA < valB) return sortOrder == 'asc' ? -1 : 1;
				if (valA > valB) return sortOrder == 'asc' ? 1 : -1;
				return 0;
			});

			return files;
		},
		sortOrderLabel() {
			return this.sortOrder == 'asc' ? '↑' : '↓';
		},


	},
	created() {
		this.idEnteCorrente = this.$root.idEnteCorrente;
		this.goToRoot()
	},
	mounted() {
		window.addEventListener('keydown', this.handleKeyNavigation)
		const modal = document.getElementById('modalPreview');
		if (modal) {
			modal.addEventListener('hidden.bs.modal', () => {
				if (this.previewFile) {
					this.handleEditorClose();
				}
			});
		}
	},
	beforeUnmount() {
		window.removeEventListener('keydown', this.handleKeyNavigation)
	},
	watch: {
		selectedFiles(val) {
			if (val.length == 0) {
				this.$forceUpdate();
			}
		}
	}
}
</script>
<style scoped>
.file-card {
	background-color: transparent;
	border: none;
	box-shadow: none;
	transition: all 0.2s ease-in-out;
	cursor: pointer;
}

.file-card:hover {
	border: 1px solid #0d6efd;
	background-color: rgba(13, 110, 253, 0.05);
}

.file-card.selected {
	background-color: rgba(13, 110, 253, 0.1);
	border: 2px solid #0d6efd;
}

.selection-bar {
	background-color: #f0f0f0;
	border-radius: 6px;
	padding: 4px 8px;
	border: 1px solid #ddd;
	box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}

.uploaded-preview-bar::-webkit-scrollbar {
	height: 6px;
}

.uploaded-preview-bar::-webkit-scrollbar-thumb {
	background: #ccc;
	border-radius: 3px;
}
</style>